import ActionInput from 'automation-ui-action-features/action-inputs/records/ActionInput';
import { DEFAULT_LANGUAGE } from 'automation-ui-action-features/actions/custom-code/DefaultFunctionDefinitionValues';
import * as CustomCodeActionMetadataKeys from 'automation-ui-action-features/actions/custom-code/constants/CustomCodeActionMetadataKeys';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import { Map as ImmutableMap, List, Record } from 'immutable';
export default class CustomCodeActionMetadata extends Record({
  [CustomCodeActionMetadataKeys.ACTION_TYPE]: ActionTypes.CUSTOM_CODE,
  // this is deprecated in favor of ACTION_TYPE_ID. Keeping it around until it is fully removed.
  [CustomCodeActionMetadataKeys.FUNCTION_ID]: null,
  [CustomCodeActionMetadataKeys.ACTION_TYPE_ID]: null,
  [CustomCodeActionMetadataKeys.FUNCTION_SOURCE]: null,
  [CustomCodeActionMetadataKeys.RUNTIME]: DEFAULT_LANGUAGE,
  [CustomCodeActionMetadataKeys.SECRETS]: [],
  [CustomCodeActionMetadataKeys.INPUT_FIELDS]: null,
  [CustomCodeActionMetadataKeys.PACKAGE_ID]: null,
  [CustomCodeActionMetadataKeys.DESCRIPTION]: null
}, 'CustomCodeActionMetadata') {
  constructor(props) {
    const propMap = ImmutableMap(props);
    const inputFields = propMap.get(CustomCodeActionMetadataKeys.INPUT_FIELDS);
    super(propMap.set(CustomCodeActionMetadataKeys.INPUT_FIELDS, inputFields ? List(inputFields.map(input => new ActionInput(input))) : null));
  }
  getActionTypeId() {
    return this.get(CustomCodeActionMetadataKeys.ACTION_TYPE_ID);
  }
  getSecrets() {
    return this.get(CustomCodeActionMetadataKeys.SECRETS);
  }
  getInputFields() {
    return this.get(CustomCodeActionMetadataKeys.INPUT_FIELDS);
  }
  setInputFields(inputFields) {
    return this.set(CustomCodeActionMetadataKeys.INPUT_FIELDS, inputFields !== null ? List(inputFields.map(input => new ActionInput(input))) : null);
  }
  getNamedInput() {
    const inputFields = this.getInputFields();
    return inputFields !== null ? inputFields.reduce((acc, input) => {
      const inputName = input.getName();
      if (inputName) {
        return acc.push(input);
      }
      return acc;
    }, List()) : List();
  }
}